import { en } from "./en";

export const fr: typeof en = {
  "commentary-bar.pre-start": "La course est sur le point de commencer !",
  "commentary-bar.race-start": "Et c'est parti !",
  "control-panel.cycle-horses": "Défiler chevaux",
  "countdown-clock.event-starts": "Début de la course: ",
  "markets-panel.header.form": "Forme",
  "markets-panel.header.winner": "Gagnant",
  "markets-panel.loading": "Chargement des concurrents...",
  "markets-panel.label": "Virtually Sports Courses de chevaux",
  "swipe-screen": "COURSES DE CHEVAUX",
};
